import MyTeamList from './entities/my-team-list';
import TeamMemberRoles from './entities/team-member-roles';
import TeamMemberDetails from './entities/team-member-details';
import TeamMemberStatistics from './entities/team-member-statistics';

export default {
  modules: {
    MyTeamList,
    TeamMemberRoles,
    TeamMemberDetails,
    TeamMemberStatistics,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/my-team/index.js